import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["variant", "children", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { useTextTokens } from '../../providers/text-token-provider';
import { jsx as _jsx } from "react/jsx-runtime";
export var TagCategory = function TagCategory(_ref) {
  var _textTokens$tagCatego;

  var variant = _ref.variant,
      children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var textTokens = useTextTokens();
  var translatedText;

  if (typeof children === 'string' && textTokens !== null && textTokens !== void 0 && (_textTokens$tagCatego = textTokens.tagCategories) !== null && _textTokens$tagCatego !== void 0 && _textTokens$tagCatego[children]) {
    translatedText = textTokens.tagCategories[children];
  }

  return /*#__PURE__*/_jsx(Badge, _objectSpread(_objectSpread({
    pill: true,
    bg: "none",
    className: classNames(className, 'border px-150 py-50 rounded-500 tag-category', _defineProperty({}, "tag-category-".concat(variant), variant))
  }, rest), {}, {
    children: translatedText || children
  }));
};